import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { TranslationKeys } from '../../../i18n';

const Footer: React.FC = () => {
 const { t, i18n } = useTranslation<TranslationKeys>();
    return (
        <Box
            component="footer"
            sx={{
                py: { xs: 0.5, sm: 1 },
                px: { xs: 1.5, sm: 2 },
                backgroundColor: '#f5f5f5',
                borderTop: '1px solid #e0e0e0',
                minHeight: 'clamp(30px, 5vw, 45px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography 
                variant="body2" 
                color="text.secondary" 
                align="center"
                sx={{ 
                    fontSize: 'clamp(0.625rem, 1vw, 0.75rem)',
                }}
            >
                © {new Date().getFullYear()} {t('footer_text')}
            </Typography>
        </Box>
    );
};

export default Footer;
